<template>
  <div>
    <!-- Navbar -->
    <div class="w3-top">
    <div class="w3-bar w3-theme-d2 w3-left-align w3-large">
      <div style="max-width:1368px; margin:auto">
        <auth-header />
      </div>
    </div>
    </div>

    <!-- Page Container -->
<!--
    <loading :active="!isAuthenticated && isAuthRequired" :can-cancel="false"></loading>
-->
    <loading-indicator v-if="!isInitialized" v-bind:fullPage="true" />
    <component v-else v-bind:is="currentPage" />
    <br>

    <!-- Footer -->
    <!--   
    <footer class="w3-container w3-theme-d3 w3-padding-16">
      <h5>Footer</h5>
    </footer>

    <footer class="w3-container w3-theme-d5">
      <p>Powered by <a href="https://www.w3schools.com/w3css/default.asp" target="_blank">w3.css</a></p>
    </footer>
    -->
 
  </div>
</template>

<script>
  import MainLayout from './MainLayout.ts'
  export default MainLayout
</script>
